// TypeScript
// import { D2DRequest } from "../apiUtils";
import { D2DRequestsFilters } from "../../../../api/d2d/d2dApiInterfaces";
import { D2DOrderRow } from "../components/D2DActionMenu/D2DActionMenu";

export interface D2DRequestsState {
  requests: D2DOrderRow[];
  totalRequests: number;
  currentPage: number;
  pageRowSize: number;
  isLoading: boolean;
  isTechnicalError: boolean;
  filters: D2DRequestsFilters;
}

export const getInitialState = (): D2DRequestsState => ({
  requests: [],
  totalRequests: 0,
  currentPage: 1,
  pageRowSize: 10,
  isLoading: false,
  isTechnicalError: false,
  filters: {},
});

export const d2dRequestsReducer = (
  state: D2DRequestsState,
  action: any
): D2DRequestsState => {
  switch (action.type) {
    case "SET_PAGE":
      return { ...state, currentPage: action.payload };
    case "SET_PAGE_ROW_SIZE":
      return { ...state, pageRowSize: action.payload, currentPage: 1 };
    case "SET_LOADING":
      return { ...state, isLoading: action.payload };
    case "SET_DATA":
      return {
        ...state,
        requests: action.payload.requests,
        totalRequests: action.payload.totalCount,
      };
    case "SET_ERROR":
      return { ...state, isTechnicalError: action.payload };
    case "SET_FILTERS":
      return { ...state, filters: action.payload, currentPage: 1 };
    case "UPDATE_ROW": {
      // Update a single row in place, preserving position and other rows
      const { id, partial } = action.payload;
      const updatedRequests = state.requests.map((row) =>
        row.id === id ? { ...row, ...partial } : row
      );
      return { ...state, requests: updatedRequests };
    }
    case "MERGE_SERVER_DATA": {
      // Merge server data while preserving current row order and positions
      // This ensures that after status changes, the row stays in the same place
      const serverRows = action.payload.requests;
      const serverById = new Map(serverRows.map((r: D2DOrderRow) => [r.id, r]));

      // Update existing rows with server data while keeping their positions
      const mergedRequests = state.requests.map((currentRow) => {
        const serverRow = serverById.get(currentRow.id);
        if (serverRow) {
          // Merge server data but preserve the row's position
          return { ...currentRow, ...serverRow };
        }
        // Row not in server response - keep current state
        return currentRow;
      });

      return {
        ...state,
        requests: mergedRequests,
        // Only update total if server provides a valid count
        totalRequests:
          action.payload.totalCount > 0
            ? action.payload.totalCount
            : state.totalRequests,
      };
    }
    default:
      return state;
  }
};
